module.exports = __webpack_public_path__ + "img/iphone69_screenshot-3.d4c8ef8d.jpeg";